import React, { Component } from 'react';

import GlobalHelper from '../../../../Common/Helpers/GlobalHelper';

class Datos extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        const {integrante}=this.props;

        return (
            
                <div className="contenedorDatosIntegranteCuenta">
                    <div className='CuentaSeleccionContainer'>
                    <div className="bottom-separator contenedorDatosProceso bottom-separator-xs">
                            <h2 className='tituloDatosIntegrantes'>
                                Datos
                            </h2>
                        </div>
                    </div>
                    <div className='CuentaSeleccionContainer'>
                        <div className="columnaDatosIntegranteLeft">
                            <div className="">
                                <div className="InfoIntegrantes">Número</div>
                                <div className="InfoDatoIntegrantes">{integrante.NumeroTarjeta}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">Fecha de vencimiento</div>
                                <div className="InfoDatoIntegrantes">{integrante.FechaVencimiento}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">Tipo de Tarjeta</div>
                                <div className="InfoDatoIntegrantes">{integrante.TipoTarjeta}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">Vínculo</div>
                                <div className="InfoDatoIntegrantes">{integrante.VinculoTarjeta}</div>
                            </div>
                        </div>
                        <div className="columnaDatosIntegranteRight">
                            <div className="">
                                <div className="InfoIntegrantes">Denominación</div>
                                <div className="InfoDatoIntegrantes">{integrante.DenominacionTarjeta}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">Denominación 4° línea</div>
                                <div className="InfoDatoIntegrantes">{integrante.DenominacionCuartaLinea ? integrante.DenominacionCuartaLinea : "-"}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">Estado</div>
                                <div className="InfoDatoIntegrantes">{integrante.EstadoTarjeta}</div>
                            </div>

                        </div>
                        
                    </div>
                </div>
            
        );
    }
}

export default Datos;